module.exports = __webpack_public_path__ + "static/Gotham-LightItalic-6597155df06e352dbd3998bd31e9d9a8.woff";